// =====================================
//
//   Home Controller
//   Author: Mark
//   createtime: 2018 / 02 / 13
//
// =====================================

window.InifECMobileApp.controller("HomeController", ['$scope', '$state', '$timeout', 'ProductService', 'AdblockService', '$ProductFormatService',
	function($scope, $state, $timeout, ProductService, AdblockService, $ProductFormatService) {
        
        var getProductClassListLite = function() {

            ProductService.getProductClassListLite().then(function(result) {

                if(result) {
                    
                    $scope.pdtClassList = $ProductFormatService.getPdtClassList('HOME');

                    if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
                        var _result = shallowCopy(result);
                    
                        $scope.pdtClassList = $ProductFormatService.formatHomePdtClassList(_result, $scope.classifiedADMap);
                    }

                }
                $scope.isLoading = false;

            }, function(error) {
                $scope.isLoading = false;
                $scope.isError = true;
            });
        }

        // ------------------------------
        // 取得所有分類廣告
        // ------------------------------
        var getAllClassifiedAD = function(callback) {

            AdblockService.getAllClassifiedAD().then(function(result) {

                if(result) {
                    $scope.classifiedADMap = result;
                }

                callback();
            }, function(error) {
                callback();
            });
        }
        // --------------------------------
        // [private] 取得首頁廣告
        // --------------------------------
        var getMobileIndexADRotion = function() {
            $scope.isLoadingIndexAd = true
            AdblockService.getMobileIndexADRotion().then(function(result) {
                if(result && Array.isArray(result) && result.length > 0) {
                    $scope.mobileIndexADRotion = result;
                    $scope.dotList.length = $scope.mobileIndexADRotion.length;
                    $scope.isLoadingIndexAd = false
                }else {
                    $scope.isLoadingIndexAd = false
                }
            });
        }



        var getMobileADImage = function(adblock) {

            if(!adblock || !adblock.coverUrl) {
                return "about:blank";
            }

            var url = adblock.coverUrl;
            url = url.replace('https://', '//');
            url = url.replace('http://', '//');
            url = url.replace('/large', '/medium');
            if(location.protocol.startsWith("file")){
                url = 'http://' + url;
            }

            return url;
        }

        // ------------------------------
        // [SCOPE] 取得商品首頁封面圖
        // ------------------------------
        var getProductHomeCoverImage = function(product) {
            if(!product) {
                return "about:blank";
            }

            if(product.homeCover) {
                return product.homeCover;
            } else if (Array.isArray(product.covers) && product.covers.length > 0){
                return product.covers[0];
            } else {
                return "about:blank";
            }
        }

        // --------------------------------
        // [SCOPE] 讀取廣告圖片
        // --------------------------------
        var getADBlockImage = function(adblock) {
            
            if(!adblock || !adblock.coverUrl) {
                return "about:blank";
            }

            return adblock.coverUrl;
        }
        // ------------------------------
        // [SCOPE] 取得分類首頁封面圖
        // ------------------------------
        var getPdtClassHomeCoverImage = function(pdtClass) {

            if(!pdtClass) {
                return "about:blank";
            }

            if(pdtClass.coverurl) {
                return pdtClass.coverurl;
            } else if (pdtClass.mobileCoverurl){
                return pdtClass.mobileCoverurl;
            } else {
                return "about:blank";
            }
        }



        var init = function() {

            $scope.isLoading = true;

            getAllClassifiedAD(function() {
                getProductClassListLite();
                getMobileIndexADRotion();
            });
        }
        //==========================
        //  Members
        //==========================
        
        $scope.state;
        $scope.isLoading = false;
        $scope.isError = false;
        $scope.pdtClassList = [];
        $scope.mobileIndexADRotion = [];
        $scope.currentClass = undefined;
        $scope.dotList = [];
        $scope.isShowPdtCover = false; // 用來延遲圖片顯示時間
        $scope.isLoadingIndexAd = false;
        $scope.classifiedADMap;
        //==========================
        //  Methods
        //==========================
        $scope.getProductHomeCoverImage = getProductHomeCoverImage; // 取得商品首頁封面圖
        $scope.getADBlockImage = getADBlockImage; // 讀取廣告圖片
        $scope.getPdtClassHomeCoverImage = getPdtClassHomeCoverImage; // 取得分類首頁封面圖
        $scope.getMobileADImage = getMobileADImage;
        //==========================
        //  Init
        //==========================

        init();
        
	}
]);